import {
	forgetShellHome,
	getRememberedShellHome,
	isHandingOff,
	takeShellHandoffEmail,
	withShellParams,
} from 'src/_shared/shell.js';
import { getShellHandoffUrl } from './shellHandoff.js';

/**
 * Where a mobile-shell install should be before anyone signs in (ERIN-8561).
 *
 * - White-label hosts: the company behind the host carries the erinai flag →
 *   its portal URL. Read on every launch, so clearing the flag takes effect
 *   on the next open.
 * - The shared host (app.erinapp.com): the company is only known after
 *   sign-in, so the hand-off remembers the portal in localStorage. It is
 *   re-checked through `fetchCompany` when that returns whiteLabelSettings
 *   (graphql proxy PR #4); until then the remembered portal is trusted.
 *
 * Returns the portal URL, or null to stay on this app.
 */
export const resolveShellPortal = async (hostCompany, fetchCompany) => {
	const byHost = getShellHandoffUrl(hostCompany);
	if (byHost) return byHost;

	const home = getRememberedShellHome();
	if (!home) return null;
	if (home.companyId && fetchCompany) {
		try {
			const company = await fetchCompany(home.companyId);
			if (company && 'whiteLabelSettings' in company) {
				const url = getShellHandoffUrl(company);
				if (!url) forgetShellHome();
				return url;
			}
		} catch {
			// Lookup failed: keep the last known home rather than strand the user.
		}
	}

	return home.url;
};

/** Sends the shell to the portal when one applies; true when navigating. */
export const routeShellToPortal = async (hostCompany, fetchCompany) => {
	// The logout page is already navigating there with the hand-off email.
	if (isHandingOff()) return false;
	const url = await resolveShellPortal(hostCompany, fetchCompany);
	if (!url || isHandingOff()) return false;
	window.location.replace(
		withShellParams(url, { email: takeShellHandoffEmail() })
	);
	return true;
};
